import { t } from "@/i18n-js/instance";
import { dateIsPast } from "@circle-react/helpers/dateTimeHelpers";
import { dateStringToTimeAgo } from "@circle-react/helpers/dateTimeHelpers/timeAgo";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { STATUS } from "../helpers/constants";
import "./styles.scss";

interface CounterProps {
  endsAt: string;
  startsAt: string;
  status?: string | null;
}

export const Counter = ({ startsAt, endsAt, status = null }: CounterProps) => {
  const isDraft = status === STATUS.DRAFT;
  const isFinished = dateIsPast(endsAt);
  const isStarted = dateIsPast(startsAt);

  let label = null;
  if (isStarted && !isFinished && !isDraft) {
    label = t("events.details.in_progress");
  } else if (isDraft) {
    label = t("events.details.draft");
  } else if (isFinished) {
    label = t("events.details.finished", {
      time_string: dateStringToTimeAgo(endsAt),
    });
  } else {
    label = t("events.details.starts", {
      time_string: dateStringToTimeAgo(startsAt),
    });
  }

  return (
    <div
      className={classNames("event-counter-badge", {
        "event-counter-badge--finished": isFinished,
        "event-counter-badge--draft": isDraft,
      })}
    >
      {`${label}`}
    </div>
  );
};
